module.exports = "/logo-white-016a9460f68d8e5ac1f1ec82b64b8f74.svg";